import { render, staticRenderFns } from "./WhatIfForcPerformanceComparisons.vue?vue&type=template&id=5d444c93&scoped=true&"
import script from "./WhatIfForcPerformanceComparisons.vue?vue&type=script&lang=js&"
export * from "./WhatIfForcPerformanceComparisons.vue?vue&type=script&lang=js&"
import style0 from "./WhatIfForcPerformanceComparisons.vue?vue&type=style&index=0&id=5d444c93&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d444c93",
  null
  
)

export default component.exports